import { render, staticRenderFns } from "./RestDayNew.vue?vue&type=template&id=ed157ff6"
import script from "./RestDayNew.vue?vue&type=script&lang=js"
export * from "./RestDayNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports